import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match.");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, new_password: pw });
      setSession(data.token, data.user);
      toast.success("Account activated! Let's get you signed up.");
      navigate("/signup");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token)
    return (
      <AuthLayout title="Invalid link">
        <p className="text-muted-foreground" data-testid="setup-invalid-msg">This setup link is missing or invalid.</p>
      </AuthLayout>
    );

  return (
    <AuthLayout title="Activate your account" subtitle="Set your password to finish activating your account.">
      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2">
          <Label htmlFor="pw">New password</Label>
          <Input id="pw" data-testid="setup-password-input" type="password" required minLength={6} value={pw}
            onChange={(e) => setPw(e.target.value)} className="h-11" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pw2">Confirm password</Label>
          <Input id="pw2" data-testid="setup-password-confirm-input" type="password" required value={pw2}
            onChange={(e) => setPw2(e.target.value)} className="h-11" />
        </div>
        <Button data-testid="setup-submit-btn" type="submit" disabled={loading} className="h-11 w-full rounded-full">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Activate & Continue"}
        </Button>
      </form>
    </AuthLayout>
  );
}
